module.exports = __webpack_public_path__ + "static/media/IPEC-Americas-vector.ca8638b4.png";